import React from 'react';
import { PumpEditTemplate } from 'themes/application/pumps/components';
import { observer } from 'mobx-react';
import { PumpEditViewStore } from 'application/pumps/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new PumpEditViewStore(rootStore, componentProps), 'editView')
@observer
class PumpEdit extends React.Component {
    render() {
        return <PumpEditTemplate {...this.props} />
    }
}

export default PumpEdit;